import styled from "@emotion/styled";
import { Input as F7Input } from "framework7-react";
import { useCallback, useMemo } from "react";

import { formatShortDate, formatShortDateWithYear } from "@/config/date-fns";
import { useCalendarStore } from "@/stores/calendarStore";

const Input = styled(F7Input)`
  ::after {
    content: "" !important;
    display: none !important;
  }
  input {
    text-align: center;
  }
`;

function formatValue(values: Date[]) {
  if (!values || values.length === 0) return "";
  const weekStart = values[0];
  const weekEnd = values[1];
  if (!weekStart || !weekEnd) return "";
  return `${formatShortDateWithYear(weekStart)} - ${formatShortDate(weekEnd)}`;
}

export function WeeklyReviewPageTitle() {
  const {
    weekly: { select, weekStart, weekEnd },
  } = useCalendarStore();

  const value = useMemo(() => {
    return [weekStart, weekEnd];
  }, [weekEnd, weekStart]);

  const onCalendarChange = useCallback<(calendarValues: Array<Date> | undefined) => void>(
    (calendarValues) => {
      if (calendarValues?.length === 1) {
        select(calendarValues[0]);
      }
    },
    [select],
  );

  return (
    <Input
      key={value.join("-")}
      readonly
      calendarParams={{
        formatValue,
        maxDate: new Date(),
        rangePicker: true,
        rangePickerMaxDays: 7,
        rangePickerMinDays: 7,
      }}
      placeholder="Your birth date"
      style={{ border: "none" }}
      type="datepicker"
      value={value}
      onCalendarChange={onCalendarChange}
    />
  );
}
